var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-387.000000, -4170.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.000000, 4050.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.500000, 136.000000) scale(-1, 1) translate(-27.500000, -136.000000) translate(7.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.8962963 C0,12.5234299 1.44280082,8.19754726 4.32844575,4.91851852 C7.21409067,1.63948978 11.4222597,0 16.9530792,0 L16.9530792,7.46666667 C12.7047686,7.46666667 10.5806452,10.1530596 10.5806452,15.5259259 L10.5806452,17.3037037 L18.2756598,17.3037037 L18.2756598,32 L2.52492669,32 C0.841633812,27.2592356 0,22.558048 0,17.8962963 Z M22.8445748,17.8962963 C22.8445748,12.5234299 24.2673367,8.19754726 27.1129032,4.91851852 C29.9584698,1.63948978 34.1465999,0 39.6774194,0 L39.6774194,7.46666667 C35.5092656,7.46666667 33.4252199,10.1530596 33.4252199,15.5259259 L33.4252199,17.3037037 L41,17.3037037 L41,32 L25.2492669,32 C23.6461308,27.1802228 22.8445748,22.4790353 22.8445748,17.8962963 Z",
    transform: "translate(20.500000, 16.000000) rotate(-180.000000) translate(-20.500000, -16.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.2c5d505ccb96fd5fee4b969cb66056a1.svg";
export { ForwardRef as ReactComponent };